// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.earnings_earnings-header__a42IZ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: var(--white);
    border-bottom: 1px solid var(--referral-gray);
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    position: relative;
    height: 68px;
  }

  .earnings_title__Hp7qR{
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
  }
  
  .earnings_sticky__wj1w- {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    max-width: 500px;
    margin: auto;
  }
  
  .earnings_left__iWHnr {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .earnings_back-arrow__Fr4ug {
    color: purple;
    font-size: 16px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    margin: auto;
    text-align: center;
    justify-content: center;
  }
  
  .earnings_right__efj1W {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .earnings_smiley__0RGZA {
    font-size: 22px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Header/MyEarnings/earnings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB","sourcesContent":[".earnings-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    background: var(--white);\n    border-bottom: 1px solid var(--referral-gray);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19px;\n    position: relative;\n    height: 68px;\n  }\n\n  .title{\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19px;\n  }\n  \n  .sticky {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    max-width: 500px;\n    margin: auto;\n  }\n  \n  .left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .back-arrow {\n    color: purple;\n    font-size: 16px;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    margin: auto;\n    text-align: center;\n    justify-content: center;\n  }\n  \n  .right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .smiley {\n    font-size: 22px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"earnings-header": `earnings_earnings-header__a42IZ`,
	"title": `earnings_title__Hp7qR`,
	"sticky": `earnings_sticky__wj1w-`,
	"left": `earnings_left__iWHnr`,
	"back-arrow": `earnings_back-arrow__Fr4ug`,
	"right": `earnings_right__efj1W`,
	"smiley": `earnings_smiley__0RGZA`
};
export default ___CSS_LOADER_EXPORT___;
